import React from 'react';
import { getTrackingData } from '@teko/tracking';
import { MessengerColored } from '@teko/ds-icon';
import { styled } from '@teko/ds-desktop';
import FbChatFull from 'assets/mess-logo-full.svg';

interface IMessengerIconProps {
  url: string;
  responsiveIcon?: boolean;
  position?: string;
  bottom?: number;
  right?: number;
}

const Wrapper = styled.div(
  ({
    responsiveIcon,
    position,
    bottom,
    right,
  }: Pick<
    IMessengerIconProps,
    'responsiveIcon' | 'position' | 'bottom' | 'right'
  >) => `
  z-index: 1030;
  ${!!position ? `position: ${position}` : ''};
  ${!!right ? `right: ${right}rem` : ''};
  ${!!bottom ? `bottom: ${bottom}rem` : ''};
  cursor: pointer;
  ${
    responsiveIcon
      ? `@media (min-width: 1440px) {
    .fb-chat-full {
      display: block;
    }
    .fb-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .fb-chat-full {
      display: none;
    }
    .fb-chat {
      display: block;
    }
  }`
      : ''
  }
  @media print {
    display: none;
  }
`,
);

export const MessengerIcon: React.FC<IMessengerIconProps> = (props) => {
  const { url, responsiveIcon, ...rest } = props;

  return (
    <Wrapper
      onClick={() => window.open(url, '_blank')}
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'quickAction',
        contentName: 'fbMessengerIcon',
        payload: JSON.stringify({ url }),
      })}
      responsiveIcon={responsiveIcon}
      {...rest}
    >
      {!!responsiveIcon && (
        <img
          src={FbChatFull}
          className="fb-chat-full"
          alt="fb-chat"
          width={110}
          height={75}
        />
      )}
      <MessengerColored size={60} className="fb-chat" />
    </Wrapper>
  );
};
